var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.editor
    ? _c(
        "div",
        {
          staticClass: "editor-wrapper",
          class: { "tiptap-fullscreen": _setup.isFullScreen },
        },
        [
          _setup.isTouched
            ? _c(_setup.TiptapToolbar, {
                attrs: {
                  editor: _setup.editor,
                  "is-full-screen": _setup.isFullScreen,
                  "is-source-mode": _setup.isSourceMode,
                  "paste-as-plain-text-active": _setup.pasteAsPlainTextActive,
                },
                on: {
                  "toggle-source": _setup.toggleSource,
                  "toggle-full-screen": function ($event) {
                    _setup.isFullScreen = !_setup.isFullScreen
                  },
                  "open-image-modal": _setup.openImageModal,
                  "update:pasteAsPlainTextActive": function ($event) {
                    _setup.pasteAsPlainTextActive = $event
                  },
                  "update:paste-as-plain-text-active": function ($event) {
                    _setup.pasteAsPlainTextActive = $event
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.EditorContent, {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_setup.isSourceMode,
                expression: "!isSourceMode",
              },
            ],
            staticClass: "flex-fill overflow-y-auto",
            attrs: { editor: _setup.editor },
          }),
          _vm._v(" "),
          _setup.isTouched
            ? _c(_setup.TiptapFooter, {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_setup.isSourceMode,
                    expression: "!isSourceMode",
                  },
                ],
                attrs: { editor: _setup.editor },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _setup.isSourceMode,
                expression: "isSourceMode",
              },
              {
                name: "model",
                rawName: "v-model",
                value: _setup.rawHtml,
                expression: "rawHtml",
              },
            ],
            staticClass: "form-control source-mode-textarea small flex-fill",
            domProps: { value: _setup.rawHtml },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _setup.rawHtml = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _setup.showImageModal
            ? _c(_setup.TipTapImageSelectionModal, {
                attrs: {
                  "form-id": _vm.formId,
                  editor: _setup.editor,
                  image: _setup.activeImageAttrs,
                },
                on: { "hide-modal": _setup.closeImageModal },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }